import BaseTable from 'components/Tables/BaseTable';
import { actions as mixtureActions } from 'ducks/mixtures';
import { actions as rawMaterialActions } from 'ducks/rawMaterials';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { filterByFieldSelector, mixtureSubstancesByMixture } from 'selectors/generic';
import { POLIMER, SUBSTANCE } from 'utils/constants/coreConstants';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/inventory/substance';

const Component = props => {
  let { mixtureId, mixtureSubstances, rawMaterialsById, substances } = props;
  const { create, fetchRawMaterial, handleCloseDrawer, handleOpenRmInserter, remove, update } = props;
  const tableRef = React.useRef(null);

  // `rawMaterialsById[mixtureId].substances` - the composition rows of this
  // mixture, which is now the mixtures slice read by mixture_id.
  const composition = mixtureSubstances[mixtureId] || [];
  const prevInterSubstanceIds = composition.map(o => o.substance_id);
  const prevInterSubstancePercents = composition.map(o => o.percentage);

  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSelectedIds(prevInterSubstanceIds);
  }, [ mixtureSubstances ]);

  // TODO Adding Checked info to table, there should be a better way
  substances = substances.map(subst => {
    if (selectedIds.includes(subst.id)) {
      const index = selectedIds.indexOf(subst.id);
      return {
        ...subst,
        tableData: { checked: true },
        percentage: prevInterSubstancePercents[index]
      };
    } else {
      return {
        ...subst,
        tableData: { checked: false },
        percentage: undefined
      };
    }
  });

  const orderedSubstances = sortBy(substances, [row => !selectedIds.includes(row.id), 'id']);


  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={handleCloseDrawer}
        title={rawMaterialsById[mixtureId].name}
        columns={columns}
        data={orderedSubstances}
        order={false}
        onRowClick={() => null}
        options={{
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false
        }}
        isLoading={loading}
        onSelectionChange={(rows, difRow) => {
          setLoading(true);
          if (rows.length > selectedIds.length) {
            create({
              mixture_id: mixtureId,
              substance_id: difRow.id,
              percentage: 0
            })
              .then(() => fetchRawMaterial(mixtureId))
              .then(() => fetchRawMaterial(difRow.id))
              .then(() => setLoading(false))
              .catch(e => {
                setLoading(false);
                alert(e);
              });
          } else {
            remove(composition.find(subst => subst.substance_id === difRow.id).id)
              .then(() => fetchRawMaterial(mixtureId))
              .then(() => fetchRawMaterial(difRow.id))
              .then(() => setLoading(false))
              .catch(e => {
                setLoading(false);
                alert(e);
              });
          }
        }}
        editable={{
          //isEditable: rowData => selectedIds.includes(rowData.id),
          onRowUpdate: (newData, oldData) => {
            setLoading(true);
            if (oldData.tableData.checked) {
              return update(composition.find(subst => subst.substance_id === newData.id).id,
                {
                  mixture_id: mixtureId,
                  substance_id: newData.id,
                  percentage: newData.percentage ? newData.percentage/100 : 0
                }
              )
                .then(() => fetchRawMaterial(mixtureId))
                .then(() => fetchRawMaterial(newData.id))
                .then(() => setLoading(false))
                .catch(e => {
                  setLoading(false);
                  alert(e);
                });
            } else {
              return create({
                mixture_id: mixtureId,
                substance_id: newData.id,
                percentage: newData.percentage ? newData.percentage : 0
              })
                .then(() => fetchRawMaterial(mixtureId))
                .then(() => fetchRawMaterial(newData.id))
                .then(() => setLoading(false))
                .catch(e => {
                  setLoading(false);
                  alert(e);
                });
            }
          }
        }}
        actions={[
          {
            icon: tableIcons.AddSubstancePolimer,
            tooltip: 'Adicionar Substância ou Polímero',
            onClick: () => handleOpenRmInserter(),
            position: 'toolbar'
          },
          {
            icon: tableIcons.AddSubstancePolimer,
            tooltip: 'Adicionar Substância ou Polímero',
            onClick: () => handleOpenRmInserter(),
            position: 'toolbarOnSelect'
          }
        ]}
      />
    </React.Fragment>
  );
};

const makeMapStateToProps = () => {
  const substancesPolimers = filterByFieldSelector('rawMaterials', 'type', [SUBSTANCE, POLIMER]);
  const mapStateToProps = (state, props) => ({
    substances: substancesPolimers(state),
    mixtureSubstances: mixtureSubstancesByMixture(state),
    rawMaterialsById: state.rawMaterials.models
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  fetchRawMaterial: id => dispatch(rawMaterialActions.fetchOne(id)),
  create: data => dispatch(mixtureActions.createPromise(data)),
  remove: id => dispatch(mixtureActions.removePromise(id)),
  update: (id, data) => dispatch(mixtureActions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
